/*! Lightweight deferred inline-script runner for Le Olive */
(function (window, document) {
  'use strict';

  var ran = Object.create(null);

  function runDeferred(id) {
    if (!id || ran[id]) return false;
    var el = document.getElementById(id);
    if (!el) return false;
    ran[id] = true;
    try {
      var s = document.createElement('script');
      s.textContent = el.textContent;
      el.textContent = '';
      el.setAttribute('data-lo-ran', '1');
      (document.body || document.documentElement).appendChild(s);
    } catch (err) {
      ran[id] = false;
      if (window.console && console.warn) console.warn('[lo-defer]', id, err);
      return false;
    }
    return true;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function onLoad(fn) {
    if (document.readyState === 'complete') {
      fn();
    } else {
      window.addEventListener('load', fn, { once: true });
    }
  }

  function schedule(fn, delay) {
    delay = delay || 0;
    onLoad(function () {
      if (delay <= 0 && 'requestAnimationFrame' in window) {
        requestAnimationFrame(function () {
          setTimeout(fn, 0);
        });
      } else {
        setTimeout(fn, delay);
      }
    });
  }

  function isCartIntent(target) {
    if (!target || !target.closest) return false;
    return !!target.closest(
      '.site-header__cart, #CartCount, a[href="/cart"], a[href$="/cart"], [href*="/cart?"], .header-cart__sidebar-open, [name="add"], form[action*="/cart/add"], .product-form__cart-submit, .add-to-cart'
    );
  }

  window.__loRunDeferred = runDeferred;
  window.__loDefer = {
    run: runDeferred,
    schedule: schedule,
    onReady: onReady,
    onLoad: onLoad,
    isCartIntent: isCartIntent
  };
})(window, document);
